var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getTimeDimensionName } from '../tag/tagUtil';
export function getComparisonLabel(c, separator) {
    if (separator === void 0) { separator = ' vs. '; }
    return c.reverse
        ? "".concat(c.optionB.title).concat(separator).concat(c.optionA.title)
        : "".concat(c.optionA.title).concat(separator).concat(c.optionB.title);
}
export function equalComparison(c1, c2) {
    // c1.optionA === c2.optionA
    var aa = c1.optionA.versionId === c2.optionA.versionId && c1.optionA.year === c2.optionA.year;
    // c2.optionB === c2.optionB
    var bb = c1.optionB.versionId === c2.optionB.versionId && c1.optionB.year === c2.optionB.year;
    // c1.optionA === c2.optionB
    var ab = c1.optionA.versionId === c2.optionB.versionId && c1.optionA.year === c2.optionB.year;
    // c1.optionB === c2.optionA
    var ba = c1.optionB.versionId === c2.optionA.versionId && c1.optionB.year === c2.optionA.year;
    return (aa && bb) || (ab && ba);
}
export function generateComparisonOptions(startYear, endYear, yearVersions, versionsById, yearTags) {
    var e_1, _a, e_2, _b;
    // flatize year versions
    var flatYearVersions = [];
    var yearsWithVersions = Object.keys(yearVersions)
        .map(Number)
        .sort(function (a, b) { return a - b; });
    try {
        for (var yearsWithVersions_1 = __values(yearsWithVersions), yearsWithVersions_1_1 = yearsWithVersions_1.next(); !yearsWithVersions_1_1.done; yearsWithVersions_1_1 = yearsWithVersions_1.next()) {
            var year = yearsWithVersions_1_1.value;
            if (year < startYear || year > endYear) {
                continue;
            }
            var versionsForYear = yearVersions[year];
            if (versionsForYear === undefined) {
                continue;
            }
            try {
                for (var versionsForYear_1 = (e_2 = void 0, __values(versionsForYear)), versionsForYear_1_1 = versionsForYear_1.next(); !versionsForYear_1_1.done; versionsForYear_1_1 = versionsForYear_1.next()) {
                    var versionId = versionsForYear_1_1.value;
                    flatYearVersions.push([year, versionId]);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (versionsForYear_1_1 && !versionsForYear_1_1.done && (_b = versionsForYear_1.return)) _b.call(versionsForYear_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (yearsWithVersions_1_1 && !yearsWithVersions_1_1.done && (_a = yearsWithVersions_1.return)) _a.call(yearsWithVersions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var comparisonOptions = [];
    for (var i = 0; i < flatYearVersions.length; i++) {
        var yearVersion1 = flatYearVersions[i];
        var _loop_1 = function (j) {
            var yearVersion2 = flatYearVersions[j];
            var year1 = yearVersion1[0];
            var year2 = yearVersion2[0];
            var yearTag1 = yearTags.find(function (t) { return t.order === year1; });
            var yearTag2 = yearTags.find(function (t) { return t.order === year2; });
            var version1 = versionsById[yearVersion1[1]];
            var version2 = versionsById[yearVersion2[1]];
            if (version1 === undefined || version2 === undefined || yearTag1 === undefined || yearTag2 === undefined) {
                return "continue";
            }
            comparisonOptions.push({
                reverse: false,
                optionA: {
                    title: "".concat(getTimeDimensionName(yearTag1), " ").concat(version1.name),
                    versionId: version1.id,
                    year: year1,
                    tag: yearTag1,
                },
                optionB: {
                    title: "".concat(getTimeDimensionName(yearTag2), " ").concat(version2.name),
                    versionId: version2.id,
                    year: year2,
                    tag: yearTag2,
                },
            });
        };
        for (var j = i + 1; j < flatYearVersions.length; j++) {
            _loop_1(j);
        }
    }
    return comparisonOptions;
}
